import { render, staticRenderFns } from "./LoanSubCategory.vue?vue&type=template&id=a0611b1a&"
import script from "./LoanSubCategory.vue?vue&type=script&lang=js&"
export * from "./LoanSubCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports